// extracted by mini-css-extract-plugin
module.exports = {"container":"fz","wrapper":"gz","hideCartCount":"hz","heading":"iz","items":"jz","side":"kz","legal":"lz","fitNotRecommended":"mz","fitCallout":"nz"};